module.exports = __webpack_public_path__ + "media/images/pc/specials/okinawa_churaumi_aquarium/bg_right-ba55fcb5ba541e0d6349cc59f55fed25.jpg";